export default {
  // layout
  LAYOUT: {
    header: {
    },
    footer: {
    },
    pageFooter: {
      ___compassBioinformatics: 'Compass Bioinformatics Inc.'
    }
  },
  // page
  PAGE: {
    main: {
      ___title: 'Select a server to continue.',
      setting: {
        ___title: 'Remember my preference',
        ___clear: 'clear setting',
        ___info: 'Enable this if you want us to remember your current settings, so you won\'t need to choose the setting again every time.'
      }
    }
  },
  // component
  COMPONENT: {
    dialog: {
      detectAlert: {
        ___content: 'We have detected that you are in <b>{target}</b>.\nWould you like to visit the <b>{target}</b> server?',
        setting: {
          ___title: 'Remember my preference',
          ___clear: 'clear setting'
        },
        button: {
          ___enter: 'Enter',
          ___another: 'Another'
        }
      },
      redirectAlert: {
        ___content: 'You\'ll be redirected to the <b>{target} server</b> in {countdown} seconds.\nNot your preference?',
        setting: {
          ___clear: 'Clear the preference setting'
        },
        button: {
          ___change: 'Change Server'
        }
      },
      toast: {
        title: {
          ___success: 'Success !',
          ___error: 'Error !'
        }
      }
    }
  },
  // common
  COMMON: {
    regionOptions: {
      ___tw: 'Taiwan',
      ___us: 'America',
      ___jp: 'Japan'
    },
    button: {
    },
    toast: {
      ___clearSetting: 'The preference setting has been reset.',
      ___clearError: 'Due to {code} error, the preference setting hasn\'t been reset. Please try again later.',
      ___noPermission: 'No Permission',
      ___pleaseLogin: 'Please Login'
    }
  }
}
